export default __webpack_public_path__ + "static/media/icon-node-tipo-explorar.8101dd4a.svg";